var _ellipse, _g, _path, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallbackImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.0977,
    cy: 46.9989,
    rx: 46.9583,
    ry: 46.55,
    fill: "#3035AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1689_4826)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.0985,
    cy: 37.4993,
    rx: 24.9167,
    ry: 24.7,
    fill: "#FFDF9C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9812 71.2063C11.1327 63.8973 17.2583 57.8374 24.641 53.7372C29.6963 60.593 37.8698 65.0464 47.0926 65.0464C56.3151 65.0464 64.4884 60.5933 69.5437 53.7378C76.9294 57.8399 83.0568 63.9033 87.2082 71.2164C78.9621 84.6081 64.0831 93.5477 47.0978 93.5477C30.1082 93.5477 15.226 84.6036 6.9812 71.2063Z",
    fill: "#FBFAFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 42.3062,
    cy: 35.5989,
    rx: 18.2083,
    ry: 18.05,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1689_4826",
    x: 21.2766,
    y: 12.7993,
    width: 50.7386,
    height: 50.3054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.905335,
    dy: 0.905335
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1689_4826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1689_4826",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackImage);
export default __webpack_public_path__ + "static/media/fallback-image.e99a8918f81f46884d23bb5536edcddb.svg";
export { ForwardRef as ReactComponent };